import { BackgroundColor as defaultBackgroundColorConfig } from 'apps/studio/components/settings/fields/Base/design'
import { FieldsIcon } from '@gocanvas/gcds/icons'

import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

export const BackgroundColor = {
  ...defaultBackgroundColorConfig,
  updateType: 'globalStyles',
}

export const GlobalStandardSettings = [
  SettingsLabel('Design'),
  BackgroundColor,
]

export const GLOBAL_SETTINGS_PANEL = 'Global'

export const GlobalSettingsPanel = (settings = []) => ({
  label: GLOBAL_SETTINGS_PANEL,
  icon: FieldsIcon,
  settings,
})
